import { observer } from 'mobx-react';
import moment from 'moment';
import { DATE_YMD } from '../../../core/configs/constants';
import { useNavigate } from 'react-router-dom';
import { APPLY_CERT_STATUS_CONFIG, USER_CURRICULUM_STATUS_CONFIG } from '../../../core/configs/ei.constants';

function EIAttendanceHistoryItem({ item, fetchData }) {
    // other
    const navigate = useNavigate();

    const getStatusText = (status) => {
        if (status === null || status === undefined || status === '') {
            return '--'
        }
        return USER_CURRICULUM_STATUS_CONFIG?.[Number(status)]?.label
    }

    const getApplyCertStatusText = (status) => {
        if (status === null || status === undefined || status === '') {
            return '--'
        }
        return APPLY_CERT_STATUS_CONFIG?.[Number(status)]?.label
    }

    return (
        <tr>
            <td width={'200px'}>
                <div>
                    {item?.curriculum?.name || '--'}
                </div>
            </td>
            <td>
                {getStatusText(item.status)}
            </td>
            <td>{item.completionDate ? moment(item.completionDate).format(DATE_YMD) : '--'}</td>
            <td>
                {item?.scoreLastTest !== null && item?.scoreLastTest !== undefined ?
                    (
                        <div>
                            {Number(item?.scoreLastTest)}%
                        </div>
                    ) :
                    (
                        <div >
                            --
                        </div>
                    )}
            </td>
            <td>
                {getApplyCertStatusText(item.applyCertStatus)}
            </td>
            <td>
                <div>
                    <span
                        style={{
                            color: '#FFFFFF',
                            backgroundColor: '#09AA6E',
                            fontWeight: 400,          // font-normal
                            lineHeight: 1,            // leading-none
                            display: 'inline-block',  // inline-block
                            borderRadius: '30px',     // rounded-[30px]
                            padding: '6px 12px'      // py-[6px] px-3 (px-3 = 12px)
                        }}
                    >研修</span>
                </div>
            </td>

        </tr>
    );
}

export default observer(EIAttendanceHistoryItem);


